import axios from "axios";
import React from "react";
import { defineMessages } from "react-intl";

import { useCreateMessage } from "src/features/notifications";

const KEY = "version";
const DELAY = 60 * 1000; // 1 minute

const messages = defineMessages({
	newVersion: {
		id: "version_check.new_version",
		defaultMessage:
			"Az alkalmazásnak új verziója érhető el. Kérjük frissítse az oldalt!"
	}
});

export const VersionCheck: React.FunctionComponent = () => {
	const createMessage = useCreateMessage();
	const intervalRef = React.useRef(0);

	React.useEffect(() => {
		const fetch = async (): Promise<string> => {
			const {
				data: { version }
			} = await axios.get<{ version: string }>("/version.json");
			return version;
		};
		const check = async (): Promise<void> => {
			const version = await fetch();
			if (localStorage.getItem(KEY) !== version) {
				createMessage(messages.newVersion);
				localStorage.setItem(KEY, version);
			}
		};
		const init = async (): Promise<void> => {
			const version = await fetch();
			localStorage.setItem(KEY, version);
			intervalRef.current = window.setInterval(check, DELAY);
		};
		init();
		return () => {
			window.clearInterval(intervalRef.current);
		};
	}, [createMessage]);

	return null;
};
